import { BigNumber, ethers } from "ethers";

export const convertBigNumberToNumber = (value: BigNumber, decimals: number = 18, onlyTotalValue: boolean = true) => {
  const tmp = ethers.utils.formatUnits(value, decimals);
  return onlyTotalValue ? Math.trunc(Number(tmp)) : Number(tmp);
};
